export default "__VITE_ASSET__CRn6M4sC__"